import { Button, Color, Font, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { usePermissions } from '@dms/hook'
import { AccessType } from 'zens-store'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
  },
  block: {
    marginTop: Spacing.M,
  },
  highlight: {
    fontFamily: Font.medium,
  },
})

interface Props {
  companyId: number
  search?: string
}
const LocationEmpty = (props: Props) => {
  const { companyId, search } = props
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  if (search) {
    return (
      <View style={styles.container}>
        <Text level={2} style={styles.text}>
          <Trans>
            No results matching{' '}
            <Text level={2} style={styles.highlight}>
              {/* @ts-expect-error Typing of vars in trans not working correctly  */}
              {{ search }}
            </Text>
          </Trans>
        </Text>
        <Text style={styles.text}>
          <Trans>Try adjusting search or filter to find what you're looking for.</Trans>
        </Text>
      </View>
    )
  }
  return (
    <View style={styles.container}>
      <Text level={2} style={styles.text}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      {hasPermission(AccessType.Create, 'location') ? (
        <>
          <Text style={[styles.text, styles.block]}>
            <Trans>Add your first location and it will be listed here.</Trans>
          </Text>
          <Link href={`/companies/${companyId}/locations/add`} asChild>
            <Button style={styles.block} title={t('Add location')} left="plus" round />
          </Link>
        </>
      ) : (
        <Text style={[styles.text, styles.block]}>
          <Trans>When a location is added it will be listed here.</Trans>
        </Text>
      )}
    </View>
  )
}

export default LocationEmpty
